import { Particle } from "../particle";
import {
	colorConstant,
	constant,
	deceleratingMotion,
	hold,
	lerp,
	randomAngle,
	randomBetween,
} from "../interpolation";

export class PlasmaSparkParticle extends Particle {
	constructor(originX: number, originY: number) {
		const angle = randomAngle();
		const speed = randomBetween(3.5, 7.0);
		const vx = Math.cos(angle) * speed;
		const vy = Math.sin(angle) * speed;

		super(originX, originY, {
			ttl: randomBetween(250, 550),
			size: lerp(0.2, 0.08),
			opacity: hold(1.0, 0.6, lerp(1.0, 0)),
			color: colorConstant(randomBetween(220, 240), randomBetween(240, 250), 255),
			rotation: constant(0),
			position: deceleratingMotion(vx, vy, 4.0),
		});
	}
}
